import React from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { Link } from "@mui/material";
import { useNavigate } from "react-router";

export default function DiscountDriver() {
  let navigate = useNavigate();
  return (
    <>
      <Box
        component={"container"}
        className="discount"
        sx={{
          display: "flex",
          flexDirection: {
            lg: "column",
            md: "column",
            sm: "column",
            xs: "column",
          },
          // width: "100vw"
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: { lg: "40px", md: "40px", sm: "30px", xs: "25px" },
              lineHeight: { lg: "56px", md: "56px", sm: "56px", xs: "40px" },
            }}
          >
            Are you ready to join as an EatCoast Driver ?
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "26.1px",
              marginTop: { lg: "0px", md: "0px", sm: "0px", xs: "20px" },
            }}
          >
            Come partner with us for flexibility in earning your own income.
            Find out the requirements and how to register here.
          </Typography>
        </Box>

        <Box>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/registerdriver")}
          >
            Become a Delivery Driver
          </Button>
        </Box>
        <Box>
          <Link href="#">See requirements to become a driver</Link>
        </Box>
      </Box>
    </>
  );
}
